<script>
export default {
  props: {
    mini: {
      default: false,
    },
  },
  computed: {
    href() {
      return `/tourclient/agency/${this.mini ? 'small' : ''}logo`;
    },
  },
};
</script>
<template>
  <div class="mag-template-logo">
    <img :src="href"/>
  </div>
</template>
<style lang="scss">
  .mag-template-logo {
    display: flex;
    min-height: 100px;
    max-height: 128px;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    line-height: 0;

    img {
    }
  }
</style>
